import { render, staticRenderFns } from "./SpineStabilization.vue?vue&type=template&id=7093039d&"
import script from "./SpineStabilization.vue?vue&type=script&lang=ts&"
export * from "./SpineStabilization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports